import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { PRIORITY_STATUS_LABELS } from "../constants"

import { FilterChip } from "@/components/common/Filters"
import { PRODUCT_STATUS_LABEL_MAP } from "@/constants/product"
import type { ComputedProductStatus, PriorityStatus } from "@/graphql/codegen/graphql"

interface CustomerProductFilterChipsProps {
  selectedComputedStatuses: ComputedProductStatus[]
  selectedPriorityStatuses: PriorityStatus[]
  onRemoveComputedStatus: (status: ComputedProductStatus) => void
  onRemovePriorityStatus: (status: PriorityStatus) => void
}

export const CustomerProductFilterChips: FC<CustomerProductFilterChipsProps> = ({
  selectedComputedStatuses,
  selectedPriorityStatuses,
  onRemoveComputedStatus,
  onRemovePriorityStatus,
}) => {
  const hasFilters = selectedComputedStatuses.length > 0 || selectedPriorityStatuses.length > 0

  if (!hasFilters) return null

  return (
    <Box className='flex flex-wrap items-center gap-2' data-testid='customer-product-filter-chips'>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>
      {selectedComputedStatuses.map((status) => (
        <FilterChip
          key={status}
          label={`Product Status: ${PRODUCT_STATUS_LABEL_MAP[status]}`}
          onDelete={() => onRemoveComputedStatus(status)}
          testId={`customer-product-status-filter-chip-${status}`}
        />
      ))}
      {selectedPriorityStatuses.map((status) => (
        <FilterChip
          key={status}
          label={`Priority: ${PRIORITY_STATUS_LABELS[status]}`}
          onDelete={() => onRemovePriorityStatus(status)}
          testId={`customer-product-priority-filter-chip-${status}`}
        />
      ))}
    </Box>
  )
}
